export { default as ClientOnly } from './main.vue';
